import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../shared/constants";

export function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter username and password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(
        `${BASE_URL}/auth/login/`,
        { username, password },
        { headers: { "Content-Type": "application/json" } },
      );
      const token = res.data.access;
      localStorage.setItem("sfp_token", token);
      localStorage.setItem("sfp_refresh_token", res.data.refresh);
      localStorage.setItem("sfp_role", res.data.role);
      localStorage.setItem("sfp_username", res.data.username);
      localStorage.setItem("sfp_first_name", res.data.first_name || res.data.username);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      onLogin(res.data.role);
    } catch (e) {
      setError("Invalid username or password.");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#2c3e50",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "48px",
          width: "360px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ fontSize: "48px" }}>🔥</div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "#2c3e50",
              marginTop: "8px",
            }}
          >
            Standard Fire Protection
          </div>
          <div style={{ fontSize: "13px", color: "#999", marginTop: "4px" }}>
            Sign in to continue
          </div>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#666",
              textTransform: "uppercase",
              display: "block",
              marginBottom: "4px",
            }}
          >
            Username
          </label>
          <input
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "6px",
              border: "1px solid #e0e0e0",
              fontSize: "14px",
              boxSizing: "border-box",
            }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            placeholder="Username"
            autoFocus
            autoComplete="off"
          />
        </div>
        <div style={{ marginBottom: "24px" }}>
          <label
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#666",
              textTransform: "uppercase",
              display: "block",
              marginBottom: "4px",
            }}
          >
            Password
          </label>
          <input
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: "6px",
              border: "1px solid #e0e0e0",
              fontSize: "14px",
              boxSizing: "border-box",
            }}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            placeholder="Password"
            autoComplete="new-password"
          />
        </div>
        {error && (
          <div
            style={{
              color: "#c0392b",
              fontSize: "13px",
              marginBottom: "16px",
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#c0392b",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </div>
    </div>
  );
}
